/** @format */

// import cookie from "js-cookie";
import { logger } from "@goldenbird1/ui-logger-library";
import { useCookies } from "react-cookie";

export const loginToApp = (keycloak, options) => {
  try{
    if (options && options.currentPath) {
      const url = keycloak.createLoginUrl({
        redirectUri:
          process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN +
          options.currentPath,
      });
      location.assign(url);
      // keycloak.login({
      //   redirectUri:
      //     process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN +
      //     options.currentPath,
      // });
    } else {
      // keycloak.login({
      //   redirectUri: process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN,
      // });
      const url = keycloak.createLoginUrl({
        redirectUri: process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN,
      });
      location.assign(url);
    }
  } catch(error) {
    logger("error", "Error while logging in:" +error, process.env.NEXT_PUBLIC_LOGGER_URL);
  }
};

export const registerToApp = (keycloak, options) => {
  try{
    if (options && options.currentPath) {
      const url = keycloak.createRegisterUrl({
        redirectUri:
          process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN +
          options.currentPath,
      });
      location.assign(url);
      // keycloak.register({
      //   redirectUri:
      //     process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN +
      //     options.currentPath,
      // });
    } else {
      const url = keycloak.createRegisterUrl({
        redirectUri: process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN,
      });
      location.assign(url);
      // keycloak.register({
      //   redirectUri: process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN,
      // });
    }
  } catch(error) {
    logger("error", "Error while registering:" +error, process.env.NEXT_PUBLIC_LOGGER_URL);
  }
};

// export const keycloakLogout = (token, buyerId, callback) => {
//   let url = process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL + '/identity/logout';
//   debugger
//   return fetch(url,{
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + token
//       },
//     }
//   ).then((res) => {
//     console.log('response from social logout', res);
//     if(res.ok){
//       return res.json();
//     } else {
//       throw 'Error from social logout';
//     }
//   }).then((resp) => { 
//     debugger
//     console.log('response from social logout', resp);
//     sessionStorage.removeItem('isSocialSignup');
//     callback(resp);
//   }).catch((err) => {
//     console.log('error from social logout', err);
//     logger("error", "Error from social logout: " +err+': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
//   });
// };

export const logoutFromApp = (keycloak, options) => {
  const [cookies, setCookie, removeCookie] = useCookies([""]);

  sessionStorage.removeItem('EDDData');
  sessionStorage.removeItem('isPendingRFQ');
  localStorage.removeItem('userProfile');
  localStorage.removeItem('loggedInUser');
  // logoutFromApp(keycloak, undefined);
  if(localStorage.getItem('kcTokenSaved') || sessionStorage.getItem('kcTokenSaved')){
    localStorage.removeItem('kcTokenSaved');
    sessionStorage.removeItem('kcTokenSaved');
    localStorage.removeItem('longTimeUser');
    localStorage.removeItem('shortTimeUser');
    localStorage.removeItem('kcAccessToken');
    localStorage.removeItem('kcRefreshToken');
    localStorage.removeItem('rValidity');
    localStorage.removeItem('aValidity');
    // removeCookie('kcAccessToken', {path: '/'});
    // removeCookie('kcRefreshToken', {path: '/'});
    router.push('/');
    window.location.reload();
  }
  // try{
  //   if (options && options.currentPath) {
  //     keycloak.logout({
  //       redirectUri:
  //         process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN +
  //         options.currentPath,
  //     });
  //   } else {
  //     keycloak.logout({
  //       redirectUri: process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN,
  //     });
  //   }
  //   cookie.remove("loggedInUser");
  //   localStorage.removeItem('loggedInUser',true)
  // } catch (error){
  //   logger("error", "Error while logging out:" +error, process.env.NEXT_PUBLIC_LOGGER_URL);
  // }
};
